<section class="hero-section">

  <!-- Heading -->
  <div class="hero-head">
    <h1 class="hero-title">
      <span class="hero-decor" aria-hidden="true">
        <span class="decor-line decor-line-1"></span>
        <span class="decor-line decor-line-2"></span>
        <span class="decor-line decor-line-3"></span>
      </span>
      Manage Your Entire Business with a Powerful<br/>
      <span class="hero-highlight">ERP</span> &amp; <span class="hero-highlight">Applications</span> in One Platform
    </h1>
  </div>

  <!-- Ecosystem block -->
  <!-- <div class="eco-block">

    <div class="eco-images-row">

      <img src="images/common/rider.png"
           alt="Rider App"
           class="eco-img eco-img--phone" />

      <img src="images/common/pos.png"
           alt="POS System"
           class="eco-img eco-img--pos" />

      <img src="images/common/customer.png"
           alt="Customer App"
           class="eco-img eco-img--phone" />

      <svg class="eco-wires-svg"
           viewBox="0 0 1000 120"
           preserveAspectRatio="none"
           aria-hidden="true">
        <defs>
          <linearGradient id="hwg1" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%"   style="stop-color:#009ebf;stop-opacity:0.3"/>
            <stop offset="50%"  style="stop-color:#009ebf;stop-opacity:0.9"/>
            <stop offset="100%" style="stop-color:#009ebf;stop-opacity:0.3"/>
          </linearGradient>
          <linearGradient id="hwg2" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%"   style="stop-color:#009ebf;stop-opacity:0.3"/>
            <stop offset="50%"  style="stop-color:#009ebf;stop-opacity:0.9"/>
            <stop offset="100%" style="stop-color:#009ebf;stop-opacity:0.3"/>
          </linearGradient>
        </defs>

        <path id="hwl" class="eco-wire"
              d="M115,60 Q227,5 440,60"
              fill="none" stroke="url(#hwg1)" stroke-width="2.5"
              stroke-dasharray="8 4"/>
        <circle r="4" fill="#009ebf" opacity="0.9">
          <animateMotion dur="2s" repeatCount="indefinite" keyPoints="1;0" keyTimes="0;1" calcMode="linear"><mpath href="#hwl"/></animateMotion>
        </circle>
        <circle r="4" fill="#009ebf" opacity="0.6">
          <animateMotion dur="2s" begin="0.67s" repeatCount="indefinite" keyPoints="1;0" keyTimes="0;1" calcMode="linear"><mpath href="#hwl"/></animateMotion>
        </circle>
        <circle r="4" fill="#009ebf" opacity="0.3">
          <animateMotion dur="2s" begin="1.33s" repeatCount="indefinite" keyPoints="1;0" keyTimes="0;1" calcMode="linear"><mpath href="#hwl"/></animateMotion>
        </circle>

        <path id="hwr" class="eco-wire"
              d="M560,60 Q773,5 885,60"
              fill="none" stroke="url(#hwg2)" stroke-width="2.5"
              stroke-dasharray="8 4"/>
        <circle r="4" fill="#009ebf" opacity="0.9">
          <animateMotion dur="2s" repeatCount="indefinite" keyPoints="1;0" keyTimes="0;1" calcMode="linear"><mpath href="#hwr"/></animateMotion>
        </circle>
        <circle r="4" fill="#009ebf" opacity="0.6">
          <animateMotion dur="2s" begin="0.67s" repeatCount="indefinite" keyPoints="1;0" keyTimes="0;1" calcMode="linear"><mpath href="#hwr"/></animateMotion>
        </circle>
        <circle r="4" fill="#009ebf" opacity="0.3">
          <animateMotion dur="2s" begin="1.33s" repeatCount="indefinite" keyPoints="1;0" keyTimes="0;1" calcMode="linear"><mpath href="#hwr"/></animateMotion>
        </circle>

      </svg>

    </div>

    <div class="eco-labels-row">
      <p class="eco-label">Rider</p>
      <p class="eco-label eco-label--pos">Store</p>
      <p class="eco-label">Customer</p>
    </div>

  </div>

  <div class="hero-actions">
    <a class="hero-act-btn" href="/ordering" target="_blank" rel="noopener noreferrer">Place your order</a>
    <a class="hero-act-btn" href="/rider/login" target="_blank" rel="noopener noreferrer">Become a rider</a>
    <a class="hero-act-btn" href="/partner" target="_blank" rel="noopener noreferrer">Create/Manage your store</a>
    <a class="hero-act-btn" [href]="playStoreUrl" target="_blank" rel="noopener noreferrer">Orderyaa POS</a>
  </div> -->

  <!-- CTA block below buttons -->
  <div class="hero-cta">
    <p class="hero-cta-text">
      orderYaa ERP Mobilizer helps businesses manage sales, inventory, accounting, HR, CRM,<br/>
      and operations — all in one place.
    </p>
    <div class="hero-cta-btns">
      <a class="hero-cta-btn hero-cta-btn--primary" routerLink="/product">Start now - it's free</a>

      <div class="meeting-dropdown" #meetingDropdown>
        <button
          type="button"
          class="hero-cta-btn hero-cta-btn--secondary"
          [attr.aria-expanded]="showMeetingOptions"
          (click)="toggleMeetingOptions()"
        >
          Book a meeting
        </button>

        <div class="meeting-options" *ngIf="showMeetingOptions">
          <button
            type="button"
            class="meeting-option"
            *ngFor="let size of companySizes"
            (click)="openMeetingLink()"
          >
            {{ size }}
          </button>
        </div>
      </div>
    </div>
  </div>

</section>
